module.exports = __webpack_public_path__ + "static/img/Fr.-Mathew-Varghese-263x300.53ea432.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/Fr.-Mathew-Varghese-263x300.jpg
// module id = K3Pk
// module chunks = 0